export default __webpack_public_path__ + "static/cd-presentation-dec20236ae99568987ef092df79f2897.png";